import EditButton from './EditButton';
import UpdateButton from './UpdateButton';
import { Box, DialogActions } from '@mui/material';
import NextPrevButton from 'components/button/NextPrevButton';

const ComptrollerModalFooterActionButton = ({
	type,
	setType,
	dataList,
	editItem,
	activate,
	pagination,
	setEditItem,
	setIsLoading,
	setPagination,
}) => {
	return (
		<DialogActions sx={{ px: 0, pb: 4, pt: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
			<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '8px' }}>
				{type === 'View' && (
					<EditButton
						handleOnClick={(e) => {
							e.stopPropagation();

							setType('Edit');
						}}
					/>
				)}

				{type === 'Edit' && <UpdateButton title="Update" disabled={activate} />}
			</Box>

			<NextPrevButton
				type={type}
				dataList={dataList}
				editItem={editItem}
				pagination={pagination}
				setEditItem={setEditItem}
				setIsLoading={setIsLoading}
				setPagination={setPagination}
			/>
		</DialogActions>
	);
};

export default ComptrollerModalFooterActionButton;
